import { render, staticRenderFns } from "./EditPicDialog.vue?vue&type=template&id=10fae87c&"
import script from "./EditPicDialog.vue?vue&type=script&lang=js&"
export * from "./EditPicDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports